<template>
  <svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBox" :width="width" :height="height">
    <title>{{ title }}</title>
    <rect x="0" y="0" :width="width" :height="height"/>
  </svg>
</template>

<script>
export default {
  name: "SkeletonRectangle",
  props: {
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
    title: {
      type: String,
      default: 'Chargement...',
    },
  },
  computed: {
    viewBox() {
      return `0 0 ${this.width} ${this.height}`
    },
  },
}
</script>

<style scoped lang="scss">
rect {
  fill: url(#loading); //whitesmoke;
}
</style>
